import httpService from "../../data-services/HTTPService";
import { AxiosResponse } from "axios";

const baseUrl = "version";

export const getVersion = async (): Promise<string | null> => {
  try {
    const response: AxiosResponse<{ version?: string }> =
      await httpService.sendMessage("get", baseUrl);
    return response.data?.version ?? null;
  } catch (error) {
    return null;
  }
};
